import { useState } from "react";
import { Table, TableBody, TableCell, TableRow } from "../../design/table";
import { Button } from "../../design/button";
import { Field } from "@headlessui/react";
import { Label } from "../../design/fieldset";
import { PlusIcon, XMarkIcon } from "@heroicons/react/20/solid";
import EmptyStateView from "../EmptyStateView";
import SelectLanguageDialog from "../Dialogs/SelectLanguageDialog/SelectLanguageDialog";

interface SelectLanguagesFieldProps {
  title?: string;
  values: string[];
  onChange: (value: string[]) => void;
}

const SelectLanguagesField: React.FC<SelectLanguagesFieldProps> = ({
  title = "Languages Spoken",
  values,
  onChange,
}) => {
  const [showDialog, setShowDialog] = useState(false);

  const onLanguageSelected = (language: string) => {
    if (!values.includes(language)) {
      onChange([...values, language]);
    }
    setShowDialog(false);
  };

  const removeLanguage = (language: string) => {
    onChange(values.filter((l) => l !== language));
  };

  return (
    <Field>
      <div className="flex items-center justify-between mb-2">
        <Label>{title}</Label>
        <Button onClick={() => setShowDialog(true)}>
          <PlusIcon className="w-5 h-5 mr-2" />
          Add
        </Button>
      </div>

      <SelectLanguageDialog
        isOpen={showDialog}
        onClose={() => setShowDialog(false)}
        onLanguageSelected={onLanguageSelected}
      />

      {values.length > 0 ? (
        <div className="overflow-hidden border rounded-lg">
          <Table>
            <TableBody>
              {values.map((lang) => (
                <TableRow key={lang}>
                  <TableCell>{lang}</TableCell>
                  <TableCell className="text-right">
                    <Button color="red" onClick={() => removeLanguage(lang)}>
                      <XMarkIcon className="w-5 h-5" />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ) : (
        <EmptyStateView
          title="No languages selected"
          message="Click the button above to add languages you speak."
        />
      )}
    </Field>
  );
};

export default SelectLanguagesField;
